import { DropdownMenuAvatar } from '@jutro/components';
import { useCallback } from 'react';
import { BurgerMenu, BurgerMenuItem, BurgerMenuLink } from '@jutro/router';
import React from 'react'
import _ from 'lodash';
import appConfig from 'app-config';
import { ImageComponent } from 'gw-components-platform-react';
import { withRouter } from 'react-router-dom';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import styles from './ApplicationHeader.module.scss';

import { Header } from '@jutro/legacy/router';

function BurgerSideMenu(props) {
   
    const auth=useAuthentication();  

    const handleClick=()=>{
       
        const {history} = props;
        return history.push('/home');
    }
    const { env } = appConfig;

    const prefix = _.get(env, 'DEPLOYMENT_PATH', '').replace(/\/$/, '');
    
    
    const getUserPermission=(permission)=>{
        const grantedAuthorities = auth.userInfo.grantedAuthorities;
        
        let availableRoles=[];
        for (const authority of grantedAuthorities) {
            const authorityRegex = /^guidewire\.edge\.(.*)\.(.*)\.(.*)$/g;
            const match = authorityRegex.exec(authority);
            availableRoles.push(match[3]);
        
        }
      
        if(availableRoles.includes(permission)===true || availableRoles.includes('useradmin')===true)
        {
            return true
        }
        return false
       
    }

    return (
    
        <Header className={styles.header} >
            <BurgerMenu
                burgerContent={[
                   // <BurgerMenuLink key="item" id="item" isContainerOnly className={styles.headerLine} />,
                    <><BurgerMenuLink key="item" id="item" to="/home" isContainerOnly>Home</BurgerMenuLink><BurgerMenuLink visible={getUserPermission('policy')} key="item" id="item" to="/policiespage" isContainerOnly>Policy</BurgerMenuLink></>,
                    <BurgerMenuLink key="item" visible={getUserPermission('billing')} id="item" to="/billing-summary" isContainerOnly>Billing</BurgerMenuLink>,
                    <BurgerMenuLink key="item" visible={getUserPermission('payroll')} id="item" to="/payroll-reporting/list/report" isContainerOnly>Payroll Reporting</BurgerMenuLink>,
                    <BurgerMenuLink key="item" visible={getUserPermission('claim')} id="item" to="/claims" isContainerOnly>Claims</BurgerMenuLink>,
                    <BurgerMenuLink key="item" visible={getUserPermission('policy')} id="item" to="/certificate" isContainerOnly>Certificates Of Insurance</BurgerMenuLink>,
                    <BurgerMenuLink key="item" visible={getUserPermission('useradmin')} id="item" to="/user-administration" isContainerOnly>User Administration</BurgerMenuLink>,
                    <BurgerMenuLink key="item" id="item" isContainerOnly>Customer Service</BurgerMenuLink>,
                    <BurgerMenuLink key="item"  id="item" href="https://www.copperpoint.com/help-center" target="_blank" isContainerOnly>Resources</BurgerMenuLink>,
                    <BurgerMenuLink key="link" id="link" href="https://www.copperpoint.com/help-center" target="_blank">Help Center/Contact Us</BurgerMenuLink>,
                    <BurgerMenuLink key="link" id="link" href="https://www.copperpoint.com/legal-privacy" target="_blank">Legal & Privacy</BurgerMenuLink>
                ]}
            />
            <div className={styles.burgerMenuCont} onClick={handleClick}>
                <ImageComponent src="../../branding/cp_new_logo_updated.png" alt="Logo"
                />
            </div>
            <DropdownMenuAvatar
                id="dropdown"
                isOpen={false}
                useAuthInfo="true"
                alignRight="false"
            />
        </Header> 
    )
}

export default withRouter(BurgerSideMenu);